import React, { type JSX } from 'react';
import EDIconButton from '../../../../../../../BaseComponents/Buttons/IconButton/EDIconButton';
import EDMenuButton from '../../../../../../../BaseComponents/Buttons/MenuButton/EDMenuButton';
import { IconType } from '../../../../../../../BaseComponents/Icon/Utils/IconDefinitions';
import { EDListItemButton } from '../../../../../../../BaseComponents/List/Components/EDListItem';
import EDTypography from '../../../../../../../BaseComponents/Typography/EDTypography';

interface IProps {
  expanded?: boolean;
  icon: IconType | JSX.Element;
  disabled?: boolean;
  disabledReason?: string;
  tooltip: string;
  onClick?: (event: React.MouseEvent<HTMLElement>) => void;
  testId?: string;
}

/**
 * Visar en knapp i BusinessCollectionMenu.
 * Visar tooltip som text bredvid knappen om menyn är expanded
 * Om den har children så är den en meny som visas när man trycker på knappen
 * annars anger man onClick för något som ska hända direkt.
 */
export const BusinessCollectionMenuItem: React.FC<
  React.PropsWithChildren<IProps>
> = props => {
  if (props.expanded) {
    return (
      <EDListItemButton
        disableVerticalPadding
        onClick={props.onClick}
        style={{ paddingLeft: '0px', paddingRight: '0px' }}
        testId={props.testId + '_Expanded'}
        disabled={props.disabled}
        disabledReason={props.disabledReason}
      >
        {props.children ? (
          <EDMenuButton
            transparentBackground
            icon={props.icon}
            tooltip={props.tooltip}
            testId={props.testId}
            margin="none"
            padding="12px 0 9.5px 28px"
            iconSize="default"
            buttonLabel={props.tooltip}
            color="inherit"
            fullwidth
          >
            {props.children}
          </EDMenuButton>
        ) : (
          <>
            <EDIconButton
              disableBackground
              icon={props.icon}
              tooltip={''}
              testId={props.testId}
              margin="none"
              paddingLeft={'28px'}
            />
            <EDTypography>{props.tooltip}</EDTypography>
          </>
        )}
      </EDListItemButton>
    );
  } else {
    return props.children ? (
      <EDMenuButton
        icon={props.icon}
        tooltip={props.tooltip}
        disabled={props.disabled}
        disabledReason={props.disabledReason}
        testId={props.testId}
        margin="none"
        padding="normal"
        iconSize="default"
      >
        {props.children}
      </EDMenuButton>
    ) : (
      <EDIconButton
        icon={props.icon}
        tooltip={props.tooltip}
        onClick={props.onClick}
        disabled={props.disabled}
        disabledReason={props.disabledReason}
        testId={props.testId}
        margin="none"
      />
    );
  }
};
